export default "__VITE_ASSET__DLAZLYdK__"